<div class="security-section">
	<data-protection></data-protection>

	<regscale-difference></regscale-difference>

	<!-- <security-architecture></security-architecture> -->

	<about-security></about-security>

	<security-blue></security-blue>
</div>

<ready-set></ready-set>
